import { Injector, NgModule } from '@angular/core'
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular'
import { ApolloClientOptions, InMemoryCache } from '@apollo/client/core'
import { HttpLink } from 'apollo-angular/http'
import { SBS_ENVIRONMENT } from '../../sbs-common.module'

// defined a merge function for scienceOrganisations, this seems to prevent a complaint about it, when deleting a scienceOrganisation
export let createApolloFactory = (httpLink: HttpLink, injector: Injector): ApolloClientOptions<any> => {
  let uri = `${injector.get(SBS_ENVIRONMENT).graphqlURL}/graphql`
  return {
    link: httpLink.create({ uri }),
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            scienceOrganisations: {
              merge(_existing, incoming) {
                return incoming
              },
            },
          },
        },
      },
    }),
  }
}

@NgModule({
  exports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApolloFactory,
      deps: [HttpLink, Injector],
    },
  ],
})
export class GraphQLModule {}
